import * as React from "react";
import BillingInfo from "../common/BillingInfo";
import { transformBillingData, calculateTotalInvoiceValue } from "../../utils/grn/grnDataUtils";
import { AnyForNow, GrnData } from "../../features/grn/types";

interface ViewGrnBillInfoProps {
  grnPaySummery?: AnyForNow[];
  grnData?: GrnData | AnyForNow;
  origin?: string;
  processResponse?: AnyForNow[];
  grnPayTax?: AnyForNow[];
  totalGross?: number | string;
  taxValues?: AnyForNow;
  grnTaxTypes?: AnyForNow[];
  grncharges?: AnyForNow[];
  addedCharges?: AnyForNow[];
  otherchargevalue?: AnyForNow[];
  calSummary?: AnyForNow;
  grncal?: AnyForNow;
}

const ViewGrnBillInfo: React.FC<ViewGrnBillInfoProps> = ({
  grnPaySummery = [],
  grnData = {},
  origin,
  processResponse = [],
}) => {

  const summary = (grnPaySummery && Array.isArray(grnPaySummery) && grnPaySummery.length > 0) ? grnPaySummery[0] : {};

  const billingDetails = transformBillingData(summary, processResponse, origin, grnData);
  const totalValue = calculateTotalInvoiceValue(summary, grnData, processResponse, origin);

  return (
    <>
      <BillingInfo
        billingDetails={billingDetails}
        totalLabel="Total Invoice Value"
        totalValue={totalValue}
      />
    </>
  );
};

export default ViewGrnBillInfo;
